export const PulseKeyStatusOptions = [
  { label: 'Unused', value: 'unused' },
  { label: 'Distributed', value: 'not redeemed' },
  { label: 'Redeemed', value: 'redeemed' },
  { label: 'Downloading', value: 'downloading' },
  { label: 'Downloaded', value: 'downloaded' },
];
export type KeyStatus =
  | 'downloaded'
  | 'downloading'
  | 'not redeemed'
  | 'redeemed'
  | 'unused';
